import TagManager from "react-gtm-module";

const gtmId = "GTM-NW3QFC5X";

export const initializeTagManager = () => {
    TagManager.initialize({gtmId});
};